import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Userslash from '../assets/img/enabled.png';
import Crying from '../assets/img/disabled.png';
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';


export default function Cardmetrice() {
  var allpack = useSelector(state => state?.sns);
  const [countData,setCountDate] =React.useState()



   useEffect(()=>{
    const countMap = {};
    allpack?.allpack && allpack?.allpack.forEach(res => {
      countMap[res.isEnable+"data"] = (countMap[res.isEnable+"data"] || 0) + 1;
    });
    setCountDate(countMap)

   },[allpack?.allpack])

   

  return (
    <>
      <Card sx={{ display: 'flex' }} className='Card'>
      <div className='Card-Icon' style={{background:" #f3ebfd"}}>
       <CardMedia
        component="img"
        sx={{width: 50, height:50 , margin: '0px'}}
        image={Userslash}
        alt="Login failure"
      />
      </div>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' ,padding:'4px 0 0 19px' }}>
          <Grid container spacing={2}>
        <Grid item xs={12} sm container minWidth={'14rem'}>
          <Grid item xs={8} md={8} sm={6} container direction="column" spacing={2} >
            <Grid item >
            <Typography component="div" variant="h5" className='Card-Text'>
            Enabled Config
          </Typography>
          {/* <Typography variant="subtitle1" color="text.secondary" component="div" className='Card-text-Percentage'>
          ProConfig
          </Typography> */}
            </Grid>
          </Grid>
          <Grid item  className='LeftText1'>
            <p className='__LeftText2'>{countData?.truedata?countData?.truedata:0}</p>
            <p className='__LeftText3'>Count</p>
          </Grid>
        </Grid>
      </Grid>
        </CardContent>
      </Box>
      
    </Card>
    <Card sx={{ display: 'flex', marginTop:'6px' }} className='Card'>
    <div className='Card-Icon' style={{background:"#d2e9e0" }}>
       <CardMedia
        component="img"
        sx={{width: 50, height:50 , margin: '0px'}}
        image={Crying}
        alt="Login failure"
      />
      </div>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' ,padding:'4px 0 0 19px' }}>
        <Grid container spacing={2}>
        <Grid item xs={12} sm container className='griddd' minWidth={'14rem'}>
          <Grid item xs={8} md={8} sm={6} container direction="column" spacing={2} >
            <Grid item >
          <Typography component="div" variant="h5" className='Card-Text'>
            Disabled Config
          </Typography>
          {/* <Typography variant="subtitle1" color="text.secondary" component="div" className='Card-text-Percentage'>
          ProConfig
          </Typography> */}
          </Grid>
          </Grid>
          <Grid item  className='LeftText1'>
            <p className='__LeftText2'>{countData?.falsedata?countData?.falsedata:0}</p>
            <p className='__LeftText3'>Count</p>
          </Grid>
        </Grid>
      </Grid>
        </CardContent>
      </Box>
      
    </Card>

    {/* <Card sx={{ display: 'flex', marginTop:'6px' }} className='Card'>
       <div className='Card-Icon' style={{background:"#f3ebfd"}}>
       <CardMedia
        component="img"
        sx={{ width: 32, height:32 , margin: '6.8px' }}
        image={FailDevice}
        alt="Login failure"
        
      />
       </div>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' ,padding:'4px 0 0 19px' }}>
        <Grid container spacing={2}>
        <Grid item xs={12} sm container minWidth={'20rem'}>
          <Grid item xs={8} md={8} sm={6} container direction="column" spacing={2} >
            <Grid item >
          <Typography component="div" variant="h5" className='Card-Text'>
            Failed Device Connection
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" className='Card-text-Percentage'>
          &#x2191; + 10.05 %
          </Typography>
          </Grid>
          </Grid>
          <Grid item  className='LeftText1'>
            <p className='__LeftText2'>302</p>
            <p className='__LeftText3'>Events</p>
          </Grid>
        </Grid>
      </Grid>
        </CardContent>
      </Box>
      
    </Card>

    <Card sx={{ display: 'flex', marginTop:'6px' }} className='Card'>
    <div className='Card-Icon' style={{background:"#f3ebfd"}}>
       <CardMedia
        component="img"
        sx={{ width: 32, height:32 , margin: '6.8px',}}
        image={Cross}
        alt="Login failure"
      />
      </div>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' ,padding:'4px 0 0 19px' }}>
        <Grid container spacing={2}>
        <Grid item xs={12} sm container minWidth={'20rem'}>
          <Grid item xs={8} md={8} sm={6} container direction="column" spacing={2} >
            <Grid item >
          <Typography component="div" variant="h5" className='Card-Text'>
            Failed System App Install
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div" className='Card-text-Percentage'>
          &#x2193; + 10.05 %
          </Typography>
          </Grid>
          </Grid>
          <Grid item  className='LeftText1'>
            <p className='__LeftText2'>279</p>
            <p className='__LeftText3'>Events</p>
          </Grid>
        </Grid>
      </Grid>
        </CardContent>
      </Box>
      
    </Card> */}
    </>

    
  );
}